import React, { useContext, useEffect, useRef, useState } from "react";
import { DContext } from "../context/Datacontext";
import ChatBotImage from "../assets/Live chatbot (1).mp4";
import { IoSend } from "react-icons/io5";

export const Chatbot = () => {
    const { BeURL } = useContext(DContext);

    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [open, setOpen] = useState(false);
    const [typing, setTyping] = useState(false);
    const [showForm, setShowForm] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: ""
    });

    const [errors, setErrors] = useState({});

    const validateForm = () => {
        let newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = "Name is required";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email";
        }

        if (!formData.phone.trim()) {
            newErrors.phone = "Phone is required";
        } else if (!/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = "Enter valid 10-digit number";
        }

        if (!formData.message.trim()) {
            newErrors.message = "Please enter your requirement";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

        // remove error while typing
        setErrors({
            ...errors,
            [e.target.name]: ""
        });
    };


    const handleSubmit = async () => {
        if (!validateForm()) return;

        try {
            const res = await fetch(`${BeURL}/lead`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            await res.json();

            pushMessage({
                type: "bot",
                text: "✅ Thank you! Our team will contact you soon."
            });

            setShowForm(false);

            setFormData({
                name: "",
                email: "",
                phone: "",
                message: ""
            });

        } catch {
            alert("Error submitting form");
        }
    };

    const chatEndRef = useRef(null);

    useEffect(() => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    useEffect(() => {
        if (open) {
            setMessages([
                { type: "bot", text: "Hi 👋 How can I help you today?" }
            ]);
        }
    }, [open]);

    const pushMessage = (msg) => {
        setMessages((prev) => [...prev, msg]);
    };



    const handleToggle = () => {
        setOpen(!open);
        setMessages([]);
        setShowForm(false);
    };

    //SEND TEXT
    const sendMessage = async () => {
        if (!input.trim()) return;

        pushMessage({ type: "user", text: input });
        setInput("");
        setTyping(true);

        try {
            const res = await fetch(`${BeURL}/chat`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ message: input })
            });

            const data = await res.json();
            pushMessage({ type: "bot", text: data.reply });
            if (data.showForm) {
                pushMessage({
                    type: "bot",
                    text: "⏳ Please wait... opening form"
                });

                setTimeout(() => {
                    setShowForm(true);
                }, 1000);
            }
            else {
                setShowForm(false)
            }

        } catch {
            pushMessage({ type: "bot", text: "Server error" });
        } finally {
            setTyping(false);
        }
    };

    useEffect(() => {
        // show preview briefly on first mount
        const timer = setTimeout(() => {
            // do nothing (preview is the always-visible element); or set a state to hide card after some time
        }, 3000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <>

            {/* Floating preview + avatar */}
            <div className="fixed z-50 bottom-6 right-6 flex items-end gap-3">
                {/* Preview Card */}
                <button
                    onClick={handleToggle}
                    aria-label="Open chat"
                    className="flex items-start gap-3 hover:scale-[1.02] transition-transform duration-200 focus:outline-none"
                >

                    {!open && (
                        <div className="flex-1 text-left group  bg-white p-2 rounded-xl">
                            <div className="flex items-center justify-between">
                                <div className="text-sm font-semibold text-gray-800">Hello! <span className="ml-1">👋</span></div>
                                {/* small close 'x' (optional) */}
                                <button
                                    onClick={(e) => { e.stopPropagation(); setOpen(true); setShowForm(false); }}
                                    className="text-xs text-gray-400 hover:text-gray-600 ml-2"
                                    title="Close"
                                    aria-hidden
                                >
                                    ✖
                                </button>
                            </div>
                            <div className="text-[13px] text-gray-500 mt-1">
                                How can we help you?
                            </div>
                        </div>
                    )}

                    {/* Avatar / bot circle */}
                    <div className="flex rounded-full border  items-center justify-center shrink-0 shadow-md transform transition-transform duration-300 group-hover:scale-105">
                        {/* use video avatar as you had, fallback emoji if not needed */}
                        <video
                            src={ChatBotImage}
                            autoPlay
                            loop
                            muted
                            playsInline
                            className="object-cover h-20 rounded-full"
                            aria-hidden
                        />
                    </div>
                </button>

                {/* Hidden smaller circular button (redundant - user can click avatar in preview) */}
                {/* if you prefer only the round avatar, uncomment/remove preview card above */}
                {/* <button onClick={handleToggle} className="w-12 h-12 rounded-full bg-yellow-400 flex items-center justify-center shadow-lg hover:scale-105 transition">
    <video src={ChatBotImage} autoPlay loop muted playsInline className="object-cover w-10 h-10 rounded-full" />
  </button> */}
            </div>

            {/* Chat UI */}
            {open && (
                <div className="fixed z-50 bottom-28 right-6 w-[350px] h-[520px] bg-white rounded-2xl shadow-xl flex flex-col">

                    <div className="bg-primary-500 text-white p-4 flex justify-between items-center rounded-t-xl">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                                <div className="w-7 h-7 rounded-full overflow-hidden  bottom-4">
                                    <video src={ChatBotImage} autoPlay loop muted playsInline className="object-cover w-full h-full" />
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold">San Technovation</div>
                                <div className="text-xs opacity-80">Expect a response from us shortly</div>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <button onClick={handleToggle}>✖</button>
                        </div></div>


                    {/* Messages */}
                    <div className="flex-1 overflow-y-auto p-3 space-y-2 bg-gray-50">

                        {messages.map((msg, i) => (
                            <div key={i}>
                                <div className={`p-2 rounded-xl max-w-[75%] ${msg.type === "user"
                                    ? "ml-auto bg-indigo-600 text-white"
                                    : "bg-white shadow"
                                    }`}>
                                    {msg.text}
                                </div>
                            </div>
                        ))}

                        {typing && <div className="text-gray-400 text-sm">Typing...</div>}

                        <div ref={chatEndRef} />
                    </div>

                    {/*PREMIUM FORM*/}
                    {showForm && (
                        <div className="mx-3 my-2 p-4 bg-white rounded-2xl shadow-lg border space-y-3">

                            {/* Header */}
                            <div className="flex justify-between items-center">
                                <div>
                                    <h2 className="text-lg font-semibold text-gray-800">
                                        Get Course Details 🎓
                                    </h2>
                                    <p className="text-xs text-gray-500">
                                        Fill the form and our team will contact you
                                    </p>
                                </div>
                                <button
                                    onClick={() => setShowForm(false)}
                                    className="text-gray-500 hover:text-red-500"
                                >
                                    ✖
                                </button>
                            </div>

                            {/* Inputs */}
                            <div className="space-y-3">

                                <div>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Your Name"
                                        className={`w-full px-3 py-2 border rounded-lg text-sm outline-none ${errors.name ? "border-red-500" : "focus:ring-2 focus:ring-primary-500"
                                            }`}
                                    />
                                    {errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
                                </div>

                                <div>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Your Email"
                                        className={`w-full px-3 py-2 border rounded-lg text-sm outline-none ${errors.email ? "border-red-500" : "focus:ring-2 focus:ring-primary-500"
                                            }`}
                                    />
                                    {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
                                </div>

                                <div>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        placeholder="Phone Number"
                                        className={`w-full px-3 py-2 border rounded-lg text-sm outline-none ${errors.phone ? "border-red-500" : "focus:ring-2 focus:ring-primary-500"
                                            }`}
                                    />
                                    {errors.phone && <p className="text-red-500 text-xs">{errors.phone}</p>}
                                </div>

                                <div>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Tell us what you're looking for..."
                                        rows="2"
                                        className={`w-full px-3 py-2 border rounded-lg text-sm outline-none ${errors.message ? "border-red-500" : "focus:ring-2 focus:ring-primary-500"
                                            }`}
                                    ></textarea>
                                    {errors.message && <p className="text-red-500 text-xs">{errors.message}</p>}
                                </div>

                            </div>

                            {/* Submit */}
                            <button
                                onClick={handleSubmit}
                                className="w-full bg-primary-600 hover:bg-primary-700 transition text-white py-2 rounded-lg font-medium shadow"
                            >
                                Submit Request
                            </button>

                        </div>
                    )}

                    {/* Input */}
                    <div className="p-2 border-t flex items-center gap-2">
                        <input
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            className="flex-1 border rounded-full px-3 py-2 text-sm"
                            placeholder="Type message..."
                            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                        />

                        <button
                            onClick={sendMessage}
                            disabled={!input}
                            className={`text-primary-600 p-2 rounded-full ${input && "bg-primary-600 text-white"}`}
                        >
                            <IoSend />
                        </button>
                    </div>

                    <p className="text-center text-xs text-gray-500 p-2">Powered by San Technovation</p>

                </div>
            )}
        </>
    );
};